export default "__VITE_ASSET__6c762ffc__"